/**
 * Geo Location Service
 *
 * Detects user's country, city, timezone, etc. using ipapi.co
 * Supports getting full response or specific fields (e.g., ip, country_code)
 * Graceful fallback if API fails
 */

const url = process.env.MIX_IPAPI_URL;
const key = process.env.MIX_IPAPI_KEY;

const GEO_API_URL = url || 'https://ipapi.co/json/';
const GEO_API_KEY = key || '';

/**
 * Fetch fresh Geo Location data from the API
 */
export async function getGeoData() {
    try {
        const res = await fetch(`${GEO_API_URL}?key=${GEO_API_KEY}`);
        if (!res.ok) throw new Error(`Geo Location request failed (${res.status})`);

        return await res.json();
    } catch (error) {
        console.warn('Geo Location lookup failed:', error);

        // Minimal fallback object
        return {
            ip: null,
            country_code: 'au',
            country_name: 'Australia',
            fallback: true,
        };
    }
}

/**
 * Get a specific field from the Geo Location data (e.g., 'ip', 'country_name', 'timezone')
 */
export async function getGeoField(field, fallback = null) {
    const data = await getGeoData();
    return data?.[field] ?? fallback;
}

/**
 * Shorthand: Get 2-letter country code (lowercase)
 */
export async function getGeoCountry() {
    const data = await getGeoData();
    return data.country_code.toLowerCase();
}

/**
 * GeoIP lookup with callback (Backwards-compatible helper)
 *
 * @param {Function} callback - Function to call with country code
 */
export function geoIpLookup(callback) {
    getGeoCountry().then(callback);
}
